export default "__VITE_ASSET__DWFKAnwt__"